function pcSyncAttributes(oldEl, freshEl) {
  Array.prototype.slice.call(oldEl.attributes).forEach(function (attr) {
    if (!freshEl.hasAttribute(attr.name)) oldEl.removeAttribute(attr.name);
  });
  Array.prototype.forEach.call(freshEl.attributes, function (attr) {
    oldEl.setAttribute(attr.name, attr.value);
  });
}

function pcSwapSectionBySelector(html, selector) {
  if (!html) return false;
  var doc = new DOMParser().parseFromString(html, 'text/html');
  var freshEl = doc.querySelector(selector);
  var oldEl = document.querySelector(selector);
  if (!freshEl || !oldEl) return false;
  oldEl.innerHTML = freshEl.innerHTML;
  pcSyncAttributes(oldEl, freshEl);
  return true;
}

function pcSwapIconBubble(html, selector) {
  if (!html) return false;
  var oldEl = document.querySelector(selector);
  if (!oldEl) return false;
  oldEl.innerHTML = html;
  return true;
}

function pcRefreshCartFallback() {
  return fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (res) { return res.json(); })
    .then(function (cartData) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cartData.item_count;
      });
      document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
        el.textContent = cartData.item_count;
      });
      return cartData;
    });
}

function pcOpenCartDrawerFallback() {
  var drawer = document.querySelector('cart-drawer') || document.querySelector('[data-cart-drawer]');
  if (drawer && typeof drawer.open === 'function') {
    drawer.open();
    return;
  }
  document.dispatchEvent(new CustomEvent('cart:open'));
}

function pcAddToCart(button) {
  if (button.disabled) return;

  var variantId = button.getAttribute('data-variant-id');
  var textEl = button.querySelector('[data-product-card-atc-text]');
  var defaultText = button.getAttribute('data-default-text');
  var addingText = button.getAttribute('data-adding-text');
  var addedText = button.getAttribute('data-added-text');

  button.disabled = true;
  if (textEl) textEl.textContent = addingText;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      items: [{ id: variantId, quantity: 1 }],
      sections: ['cart-icon-bubble', 'cart-drawer'],
      sections_url: window.location.pathname
    })
  })
    .then(function (res) {
      return res.json().then(function (data) {
        return { ok: res.ok, data: data };
      });
    })
    .then(function (result) {
      if (!result.ok) {
        var message = (result.data && (result.data.description || result.data.message)) || 'add_failed';
        throw new Error(message);
      }

      if (textEl) textEl.textContent = addedText;

      var sections = result.data.sections || {};
      var drawerSwapped = pcSwapSectionBySelector(sections['cart-drawer'], 'cart-drawer');
      pcSwapIconBubble(sections['cart-icon-bubble'], '#cart-icon-bubble');

      var freshDrawer = document.querySelector('cart-drawer');
      if (drawerSwapped && freshDrawer && typeof freshDrawer.open === 'function') {
        freshDrawer.open();
      } else {
        pcRefreshCartFallback().then(pcOpenCartDrawerFallback);
      }

      setTimeout(function () {
        if (textEl) textEl.textContent = defaultText;
        button.disabled = false;
      }, 1200);
    })
    .catch(function () {
      if (textEl) textEl.textContent = defaultText;
      button.disabled = false;
    });
}

function pcExecuteInjectedScripts(container) {
  var scripts = container.querySelectorAll('script');
  scripts.forEach(function (oldScript) {
    var newScript = document.createElement('script');
    Array.prototype.forEach.call(oldScript.attributes, function (attr) {
      newScript.setAttribute(attr.name, attr.value);
    });
    newScript.textContent = oldScript.textContent;
    oldScript.parentNode.replaceChild(newScript, oldScript);
  });
}

function pcOpenQuickView(url) {
  var modal = document.getElementById('quick-view-modal');
  var content = modal ? modal.querySelector('[data-quick-view-content]') : null;
  if (!modal || !content) return;

  content.innerHTML = '<div class="quick-view-modal__loading">Loading...</div>';
  modal.classList.add('is-open');
  modal.setAttribute('aria-hidden', 'false');
  document.body.classList.add('quick-view-open');

  fetch(url)
    .then(function (res) { return res.text(); })
    .then(function (html) {
      console.log('[QV] fetched length:', html.length);

      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('.pg-section-root');
      console.log('[QV] fresh found:', !!fresh);

      if (!fresh) {
        content.innerHTML = '<div class="quick-view-modal__loading">Something went wrong.</div>';
        return;
      }

      var freshStyle = fresh.previousElementSibling && fresh.previousElementSibling.tagName === 'STYLE'
        ? fresh.previousElementSibling
        : null;
      var freshScript = fresh.nextElementSibling && fresh.nextElementSibling.tagName === 'SCRIPT'
        ? fresh.nextElementSibling
        : null;
      console.log('[QV] style found:', !!freshStyle, 'script found:', !!freshScript);

      content.innerHTML = '';
      if (freshStyle) content.appendChild(freshStyle);
      content.appendChild(fresh);
      if (freshScript) content.appendChild(freshScript);

      console.log('[QV] appended, content children:', content.children.length);

      pcExecuteInjectedScripts(content);
      console.log('[QV] scripts executed successfully');
    })
    .catch(function (err) {
      console.error('[QV] REAL ERROR:', err);
      content.innerHTML = '<div class="quick-view-modal__loading">Something went wrong.</div>';
    });
}

function pcCloseQuickView() {
  var modal = document.getElementById('quick-view-modal');
  if (!modal) return;
  modal.classList.remove('is-open');
  modal.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('quick-view-open');
}

document.addEventListener('click', function (event) {
  var atcButton = event.target.closest('[data-product-card-atc]');
  if (atcButton) {
    event.preventDefault();
    pcAddToCart(atcButton);
    return;
  }

  var quickViewButton = event.target.closest('[data-product-card-quick-view]');
  if (quickViewButton) {
    event.preventDefault();
    pcOpenQuickView(quickViewButton.getAttribute('data-product-url'));
    return;
  }

  if (event.target.closest('[data-quick-view-close]')) {
    pcCloseQuickView();
  }
});



document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') pcCloseQuickView();
});
